import ExportCSV from '@/components/common/ExportCSV';
import HistoricSearchModal from '@/components/modal/HistoricSearchModal';
import ModuleWindow, { moduleHeaderClassName } from '@/components/mosaic/ModuleWindow';
import ModuleWindowControls from '@/components/mosaic/ModuleWindowControl';
import { useDisclosure } from '@/utils/hooks/useDisclosure';
import useLanguage from '@/utils/hooks/useLanguage';
import { tabIcon } from '@/utils/hooks/useXplorSpotLayout';
import { useScreenSizes } from '@/utils/providers/ScreenSizesProvider';
import { useState } from 'react';
import Blotters, { HistoricSearch } from '.';

const BlottersModule = (props: any) => {
    const { tradingModule } = props;

    const lang = useLanguage();
    const screen = useScreenSizes();

    const [CSVData, setCSVData] = useState<any[]>([]);
    const historicSearchDisclosure = useDisclosure(false);

    return (
        <ModuleWindow
            {...props}
            renderToolbar={() => (
                <div className={moduleHeaderClassName} dir={lang.dir}>
                    <div className="h-full flex items-center p-2 gap-2">
                        {tabIcon[tradingModule?.key || ''] && (
                            <div className="flex items-center justify-center bg-brand-neutral-700 rounded-full p-1">
                                {tabIcon[tradingModule?.key || '']({
                                    className: 'w-4 h-4',
                                    'aria-hidden': true
                                })}
                            </div>
                        )}
                        <span className="font-semibold">{tradingModule?.title}</span>

                        <div className="flex items-center h-full">
                            {(screen.laptop || screen.desktop) && (
                                <div
                                    title="Download to CSV"
                                    className="cursor-pointer hover:bg-brand-primary p-2 rounded-sm flex items-center">
                                    <ExportCSV csvData={CSVData} />
                                </div>
                            )}
                            <HistoricSearch handlers={historicSearchDisclosure[1]} />
                        </div>
                    </div>
                    <ModuleWindowControls {...props} />
                </div>
            )}>
            <div id="orders" className="h-full bg-brand-background">
                <Blotters setCSVData={setCSVData} />
            </div>
            <HistoricSearchModal opened={historicSearchDisclosure[0]} handlers={historicSearchDisclosure[1]} />
        </ModuleWindow>
    );
};

export default BlottersModule;
